import React, { useState } from 'react';
import Icon from '@/components/AppIcon';
import Button from '@/components/ui/Button';
import Input from '@/components/ui/Input';
import Select from '@/components/ui/Select';
import { ArrowLeft, Calendar, Clock, Building2, MapPin, DollarSign, Users, TrendingUp, FileText, Briefcase, Target, MessageSquare, Brain, CheckCircle, AlertCircle, ExternalLink, Plus, X, Loader } from 'lucide-react';

const PracticeSession = ({ 
interview,
handleCancelMockInterview,
setShowPracticeTimeModal,
setIsReschedule,
navigate
 }) => {


return (
<div className="mt-6 bg-purple-50 border border-purple-200 rounded-lg p-6">
<div className="flex items-center justify-between">

<div>
<div className="flex items-center gap-2 mb-2">
<Brain className="w-6 h-6 text-purple-600" />
<h3 className="text-lg font-semibold text-purple-900">
AI Mock Interview Scheduled
</h3>
</div>

<p className="text-purple-700 mb-5">
{new Date(interview.mockPracticeSession.date).toLocaleDateString('en-US', {
weekday: 'long',
month: 'long',
day: 'numeric',
year: 'numeric'
})} at {interview.mockPracticeSession.time}
</p>
</div>

<div className="flex gap-2">

<Button
variant="default"
size="sm"
onClick={() => navigate('/mock-interview/'+interview.mockPracticeSession.id)}
>
View Details
</Button>

<Button
variant="secondary"
size="sm"
onClick={() =>{ setIsReschedule(true); setShowPracticeTimeModal(true)}}
>
Reschedule
</Button>

<Button
variant="link"
size="sm"
onClick={handleCancelMockInterview}
className="text-red-600 hover:text-red-700"
>
Cancel
</Button>

</div>


</div>

<div className="flex items-start gap-2 text-sm text-purple-700 bg-purple-100 border border-purple-200 rounded p-3">
<AlertCircle className="w-4 h-4 mt-0.5 flex-shrink-0" />
<div>
<p className="font-medium mb-1">Reminder Notifications:</p>
<ul className="space-y-1">
<li>• You will receive a reminder 1 hour before</li>
<li>• You will receive a reminder 30 minutes before</li>
</ul>
</div>
</div>

</div>
);
};

export default PracticeSession;